import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPanelComponent } from './panel.component';
import { PanelHeadingComponent } from './panel-heading.component';
import { PanelBodyComponent } from './panel-body.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	exports: [
		NgxPanelComponent,
		PanelHeadingComponent,
		PanelBodyComponent
	],
	declarations: [
		NgxPanelComponent,
		PanelHeadingComponent,
		PanelBodyComponent
	]
})
export class PanelModule {}
